import * as React from "react";

import { cn } from "../lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-9 w-full rounded-crane-md border border-crane-input bg-crane-background px-3 py-1 text-sm shadow-crane-soft transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-crane-foreground placeholder:text-crane-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-crane-ring focus-visible:ring-offset-2 focus-visible:ring-offset-crane-background disabled:cursor-not-allowed disabled:opacity-50",
          // Stan błędu niesie ramka pola, nie etykieta — patrz komentarz przy `FormLabel`.
          "aria-[invalid=true]:border-crane-destructive",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
